




















































































































import Vue from 'vue'
import { columns } from './components/custom'
import { AppServiceProxy, DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { MasterlinkMenuServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import ViewEdit from './components/ViewEdit.vue'
import AddApp from './components/AddApp.vue'
import dayjs from 'dayjs'
const service = new AppServiceProxy()
const dictservice = new DictServiceProxy()
const menuservice = new MasterlinkMenuServiceProxy()
export default Vue.extend({
  components: {
    ViewEdit,
    AddApp
  },
  data() {
    return {
      columns, // 表单配置
      data: [], // 表单数据
      totalContent: 0, // 表单列表数
      fitler: {
        // 查询条件
        audience: '', // app受众
        code: '', // app编号
        current: 1, // 当前页
        displayName: '', // app名称
        size: 30 // 每页的数量
      },
      loading: false,
      selectedRowKeys: [],
      Rowkey: '', // 所选表单行
      detailTitle: '', // 详情头部
      editData: {},
      detailShow: false, // 详情展示
      clientList: [], // 客户端列表
      audienceList: [], // 受众列表
      statusList: [], // 状态列表
      salestatusList: [], //上架状态
      addShow: false,
      menuList: [],
      scrollY: window.document.body.clientHeight - 250
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps(record) {
          return ({
            style: {
              display: record.id ? 'block' : 'none'
            },
            props: {
              disabled: record.id ? false : true
            }
          })
        }
      }
    },
    buttonDisabled() {
      const { selectedRowKeys }: any = this
      return selectedRowKeys.length === 0
    }
  },
  created() {
    this.clientList = []
    this.audienceList = []
    this.statusList = []
    this.salestatusList = []
    this.load()
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    load() {
      this.fitler.current = 1
      Promise.all([
        dictservice.dictionary('client_type'),
        dictservice.dictionary('audience_category'),
        dictservice.dictionary('app_status'),
        dictservice.dictionary('app_sale_status')
      ]).then((res) => {
        this.clientList = res[0].data
        this.audienceList = res[1].data
        this.statusList = res[2].data
        this.salestatusList = res[3].data
        this.getList()
        this.getMenuList()
      })
    },
    getList() {
      this.data = []
      // this.selectedRowKeys = []
      service.pageForCode(this.fitler.current, this.fitler.code, this.fitler.size).then((res) => {
        if (res.records) {
          this.totalContent = Number(res.total)
          this.data = this.reloadData(res.records)
          let dataX = this.reloadData(res.records)
          // console.log(dataX,'bbbbbbb')

          let dataLength = dataX.length;
          let copy = dataX;
          let needPush = 0;
          if(dataLength < 30) {
            needPush = 30 - dataLength;
            for(var k=0; k<needPush; k++) {
              let obj = {  
                // id: 'none'
              }
              copy.push(obj)  
            }
          }
          this.data = copy;
          // console.log(this.data,'aaaaaaaa')


        }
      })
    },
    getMenuList() {
      this.menuList = []
      menuservice.getMenus(undefined, '1', 2, '').then((res) => {
        if (res.data && res.data.menuTreeNodeList.length > 0) {
          res.data.menuTreeNodeList.forEach((item) => {
            if (item.parentId == '0') {
              const _item = this.creatTree(item)
              delete _item.children
              this.menuList.push(_item)
            }
          })
        }
      })
    },
    creatTree(res) {
      const tree = {
        key: res.id,
        label: res.title,
        value: res.id,
        children: res.children
      }
      if (res.children && res.children.length > 0) {
        const childrenList = []
        for (let i = 0; i < res.children.length; i++) {
          childrenList[i] = this.creatTree(res.children[i])
        }
        tree.children = childrenList
      }
      return tree
    },
    reloadData(record: any) {
      record.forEach((element: any, index: number) => {
        element.key = element.id
        console.log(element,'qqqqqq')
        if(element.updateTime === undefined) {

        }
        else if(element.updateTime === null) {

        }
        else {
          console.log(element.updateTime,'oooooooooooooooooooo')
          element.updateTime = dayjs(element.updateTime).format('YYYY-MM-DD HH:mm:ss')
        
        }
        if (element.audience) {
          element.audience = this.getAudience(element.audience)
        }
      })
      return record
    },
    getAudience(element: any) {
      const audience: any = []
      const audience2 = element
      this.audienceList.forEach((res: any) => {
        const disct2 = Number(res.dictKey)
        if ((audience2 & Number(disct2)) === disct2) {
          audience.push(res.dictValue)
        }
      })
      return audience
    },

    handleSubmit() {
      const params: any = {
        appIds: this.selectedRowKeys,
        status: 1
      }
      service.deployApp(params).then((res) => {
        this.$message.success('发布成功')
        this.load()
      })
    },
    handleSearch(code: any) {
      this.fitler.code = code
      this.fitler.current = 1
      this.data = []
      this.pageIndexchange(1)
    },
    rowClick(record: any) {
      return {
        on: {
          click: (event: any) => {
            this.handleClickWork(record)
          }
        }
      }
    },
    handleClickWork(item: any) {
      if (this.detailShow) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.editData = {}
            this.detailShow = true
            this.detailTitle = item.code
            this.Rowkey = item.key
            service.appId(item.id).then((res) => {
              if (res) {
                this.editData = res
              }
            })
          },
          onCancel() {
            return
          }
        })
      } else {
        this.editData = {}
        this.detailShow = true
        this.detailTitle = item.code
        this.Rowkey = item.key
        service.appId(item.id).then((res) => {
          if (res) {
            this.editData = res
          }
        })
      }
    },
    pageIndexchange(current: any) {
      this.fitler.current = current.current
      this.getList()
    },
    closeDetail(e: any) {
      this.detailShow = false
      if (e) {
        this.load()
      }
    },
    handleAdd() {
      this.addShow = true
    },
    closeAdd(e: any) {
      this.addShow = false
      if (e) {
        this.load()
      }
    }
  }
})
